import { withInstall } from '@bigin/utils'
import Autocomplete from './src/autocomplete.vue'

export const BAutocomplete = withInstall(Autocomplete)

export default BAutocomplete

export * from './src/autocomplete'
